module.exports = __webpack_public_path__ + "img/img_user_points.175efa40.png";